import React, { useState, useEffect } from "react";
import Layouts from "../../../components/Layouts";
import { Typography, Spin } from "antd";
import { useSelector } from "react-redux";

// Reutilizamos LoansTable, GeneralSerialsUpload, SerialsModal, SummarySerialsModal, NotFoundSerialsModal
import LoansTable from "../../loans_routes/loancreate/components/LoansTable";
import GeneralSerialsUpload from "../../loans_routes/loancreate/components/GeneralSerialsUpload";
import SerialsModal from "../../loans_routes/loancreate/components/SerialsModal";
import SummarySerialsModal from "../../loans_routes/loancreate/components/SummarySerialsModal";
import NotFoundSerialsModal from "../../loans_routes/loancreate/components/NotFoundSerialsModal";
import { useVendors } from "../hooks/useVendors";
import { useLoans } from "../hooks/useLoansTropas";

import SalesmanTroopsSelect from "./SalesmanTroopsSelect";
import { useSerials } from "../hooks/useSerials";



const { Title } = Typography;

function SalesmanTroopsRepay() {
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userID = useSelector((state) => state.userdata?.id);
  const { vendors, loadingVendors } = useVendors(userID);

  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);

  useEffect(() => {
    const found = vendors.find((v) => v.id === selectedVendorId);
    setSelectedVendor(found || null);
  }, [selectedVendorId, vendors]);

  // Cambia el hook para usar prestamos_tropas
  const { loans, loadingLoans, getLoans } = useLoans(selectedVendor);

  useEffect(() => {
    if (selectedVendor) getLoans();
  }, [selectedVendor, getLoans]);

  const serials = useSerials({
    vendor: selectedVendor,
    loans,
    onLoansRefresh: getLoans,
    userBodega,

  });

  // Mapeo para mostrar productos igual que rutas
  const loansMapped = loans.flatMap((loan) => {
    console.log("prestamos", loan);

    // Serializados - solo los que están en estado 9 (prestados)
    const serialProducts = (loan.seriales || [])
      .filter((item) => item.seriales_id.estado === 9) // Solo seriales con estado 9
      .map((item) => ({
        loanId: loan.id,
        productId: item.seriales_id.producto?.id,
        product: item.seriales_id.producto?.nombre,
        isNotSerialized: false,
        quantity: 1,
        price: item.seriales_id.producto?.preciosinimp,
        tax: item.seriales_id.producto?.grupo?.impuesto,
        partialTotal: item.seriales_id.producto?.preciosinimp
          ? (
              (parseFloat(item.seriales_id.producto?.preciosinimp) || 0) *
              (1 +
                (parseFloat(item.seriales_id.producto?.grupo?.impuesto) || 0) /
                  100)
            ).toFixed(2)
          : "0",
        estado: loan.estado,
        key: `serial-${loan.id}-${item.seriales_id.id}`,
        serial: item.seriales_id.serial,
        serialId: item.seriales_id.id,
        rawLoan: loan,
      }));
    // No serializados - solo los que están en estado "prestado"
    const nsProducts = (loan.inventario_nsp || [])
      .filter((item) => item.inventario_ns_prestamo_id.estado === "prestado") // Solo productos prestados
      .map((item) => ({
        loanId: loan.id,
        productId: item.inventario_ns_prestamo_id?.inventario_ns?.id,
        product: item.inventario_ns_prestamo_id?.inventario_ns?.nombre,
        isNotSerialized: true,
        quantity: item.inventario_ns_prestamo_id.cantidad,
        price:
          item.inventario_ns_prestamo_id.inventario_ns.producto?.preciosinimp,
        tax: item.inventario_ns_prestamo_id.inventario_ns.producto?.grupo?.impuesto,
        partialTotal: item.inventario_ns_prestamo_id.inventario_ns.producto?.preciosinimp
          ? (
              (parseFloat(
                item.inventario_ns_prestamo_id.inventario_ns.producto?.preciosinimp
              ) || 0) *
              (parseFloat(item.inventario_ns_prestamo_id.cantidad) || 1) *
              (1 +
                (parseFloat(
                  item.inventario_ns_prestamo_id.inventario_ns.producto?.grupo?.impuesto
                ) || 0) /
                  100)
            ).toFixed(2)
          : "0",
        estado: loan.estado,
        key: `ns-${loan.id}-${item.inventario_ns_prestamo_id.id}`,
        rawLoan: loan,
      }));
    return [...serialProducts, ...nsProducts];
  });

  // Agrupar productos por ID para mostrar cantidad total
  const groupedProducts = loansMapped.reduce((acc, item) => {
    const key = `${item.productId}-${item.isNotSerialized}`;
    
    if (!acc[key]) {
      acc[key] = {
        ...item,
        quantity: 0,
        partialTotal: "0",
        allSerials: [],
        allLoanIds: new Set(),
      };
    }
    
    // Sumar cantidad
    acc[key].quantity += item.quantity;
    
    // Agregar seriales si es serializado
    if (!item.isNotSerialized && item.serial) {
      acc[key].allSerials.push(item.serial);
    }
    
    // Agregar loan IDs únicos
    acc[key].allLoanIds.add(item.loanId);
    
    // Recalcular total parcial
    const price = parseFloat(item.price) || 0;
    const tax = parseFloat(item.tax) || 0;
    const priceWithTax = price * (1 + tax / 100);
    const currentTotal = parseFloat(acc[key].partialTotal) || 0;
    acc[key].partialTotal = (currentTotal + (priceWithTax * item.quantity)).toFixed(2);
    
    return acc;
  }, {});

  // Convertir a array y generar keys únicas
  const finalProducts = Object.values(groupedProducts).map((item, index) => ({
    ...item,
    key: `grouped-${index}`,
    allLoanIds: Array.from(item.allLoanIds),
  }));

  return (
    <Spin
      spinning={serials.loadingGeneralSerials}
      tip="Procesando seriales..."
      size="large"
    >
      <Layouts>
        <Title level={4}>Devolver Seriales Prestados - Vendedor Tropas</Title>
        <SalesmanTroopsSelect
          vendedores={vendors}
          loading={loadingVendors}
          onChange={setSelectedVendorId}
          value={selectedVendorId}
        />
        {selectedVendor && (
          <Spin spinning={loadingLoans} tip="Cargando préstamos...">
            <LoansTable
              loans={finalProducts}
              loading={loadingLoans}
              onViewSerials={serials.onViewSerials}
              onReturnNotSerialized={serials.onReturnNotSerialized}
            />
          </Spin>
        )}
        {loans.length > 0 && (
          <GeneralSerialsUpload
            onUpload={serials.onGeneralSerialsUpload}
            fileList={serials.generalFileList}
            setFileList={serials.setGeneralFileList}
            loading={serials.loadingGeneralSerials}
          />
        )}
        <SerialsModal
          visible={serials.modalSerials}
          onClose={serials.onCloseSerialsModal}
          serialsList={serials.serialsList}
          serialsPage={serials.serialsPage}
          pageSize={100}
          serialsTotal={serials.serialsTotal}
          onPageChange={serials.onSerialsPageChange}
        />
        <SummarySerialsModal
          visible={serials.modalSummaryVisible}
          onClose={serials.onCloseSummaryModal}
          summarySerials={serials.summarySerials}
        />
        <NotFoundSerialsModal
          visible={serials.modalNotFoundVisible}
          onClose={serials.onCloseNotFoundModal}
          notFoundSerialsList={serials.notFoundSerialsList}
          notFoundSerialsPage={serials.notFoundSerialsPage}
          notFoundSerialsPageSize={serials.notFoundSerialsPageSize}
          onPageChange={serials.setNotFoundSerialsPage}
        />
      </Layouts>
    </Spin>
  );
}

export default SalesmanTroopsRepay;
